import {
  BookOpen,
  MessageCircle,
  MessagesSquare,
  type LucideIcon,
} from 'lucide-react';

import type { SchoolStudentFeatureKey } from '../modules/platform/types/featureAccess';
import { ROUTES } from '../utils/constants';

export type LmsStudentNavigationItem = {
  id: string;
  label: string;
  path: string;
  featureKey: Extract<
    SchoolStudentFeatureKey,
    'ai_tutor' | 'communication_tutor' | 'scenario_based_convo'
  >;
  icon: LucideIcon;
  childPaths?: string[];
};

/**
 * Restricted left-nav for LMS/SSO students only.
 * Keep labels, routes, and feature keys here — do not duplicate in layout components.
 */
export const LMS_STUDENT_NAV_ITEMS: LmsStudentNavigationItem[] = [
  {
    id: 'tamil-tutor',
    label: 'Tamil Tutor',
    path: ROUTES.STUDENT_TAMIL_TUTOR,
    featureKey: 'ai_tutor',
    icon: BookOpen,
  },
  {
    id: 'communication-tutor',
    label: 'Communication Tutor',
    path: ROUTES.STUDENT_COMMUNICATION_TUTOR,
    featureKey: 'communication_tutor',
    icon: MessageCircle,
  },
  {
    id: 'scenario-conversation',
    label: 'Scenario Conversation',
    path: ROUTES.STUDENT_SCENARIO_CONVERSATION,
    featureKey: 'scenario_based_convo',
    icon: MessagesSquare,
    childPaths: [ROUTES.STUDENT_SCENARIO_CLASSROOM],
  },
];
